import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const nav = [
  { to: "/", label: "ホーム" },
  { to: "/services", label: "サービス詳細" },
  { to: "/about", label: "私たちについて" },
  { to: "/company", label: "会社概要" },
  { to: "/cases", label: "事例" },
  { to: "/faq", label: "FAQ" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header id="top" className={`top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/95 backdrop-blur border-b border-background-200`}
    >
      <div className="mx-auto flex items-center justify-between px-4 md:px-10 h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
            <i className="ri-brush-ai-line text-xl"></i>
          </span>
          <span className="font-heading text-lg md:text-xl tracking-wider text-foreground-950">
            株式会社 DAISAN
          </span>
        </Link>

        <nav className="hidden min-[961px]:flex items-center gap-6">
          {nav.map((n) => {
            const active = location.pathname === n.to;
            return (
              <Link
                key={n.to}
                to={n.to}
                className={`text-sm tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                  active
                    ? "text-accent-600 font-medium"
                    : "text-foreground-700 hover:text-accent-600"
                }`}
              >
                {n.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden min-[961px]:flex items-center gap-3">
          <a
            href="tel:092-984-5214"
            className="bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-medium px-4 py-2 rounded-md whitespace-nowrap cursor-pointer transition-colors flex items-center gap-2"
          >
            <i className="ri-phone-line"></i>
            092-984-5214
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="min-[961px]:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer text-foreground-900"
          aria-label="menu"
        >
          <i className={`text-2xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="min-[961px]:hidden border-t border-background-200 bg-background-50">
          <div className="px-4 py-4 flex flex-col gap-1">
            {nav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                className="py-3 px-3 rounded-md text-foreground-800 hover:bg-background-100 text-sm cursor-pointer"
              >
                {n.label}
              </Link>
            ))}
            <a
              href="tel:092-984-5214"
              className="mt-2 bg-accent-500 text-background-50 text-sm text-center py-3 rounded-md cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              092-984-5214
            </a>
          </div>
        </div>
      )}
    </header>
  );
}